/* globals getApp swan */
import md5 from './md5';
/**
 * 获取用户信息的方法
 */
import { request } from '../utils/request';
import { reqPathTo } from '../../static/utils/env';
export const getUserInfo = () => {
  return new Promise(resolve => {
    request({
      url: reqPathTo('getuserinfo', {}, '', 'falv/user')
    }).then(res => {
      let data = res && res.data && res.data.data || {};
      resolve(data);
    }).catch(() => {
      resolve({});
    });
  });
};

/**
 * 获取加密后的搜索 query
 * @return {string} searchQuery
 */

export const getSearchQuery = () => {
  return '';
};
/**
 * 获取ctk
 * @returns 经过md5加密生成的ctk
 */

export const createCtk = () => {
  let cookie;
  let msectime = new Date().getTime();
  let randNum = Math.random(9999) * 10000;
  cookie = document.cookie;
  randNum = (Array(4).join('0') + parseInt(randNum, 10)).slice(-4);
  return '48' + md5(cookie + msectime + randNum).substring(0, 14);
};